import { v4 as uuidv4 } from 'uuid';
import * as Sentry from '@sentry/browser';
import packageJSON from '~/../package.json';

export let instanceId = '';

export function sentryInit() {
	const urlParams = new URLSearchParams(location.search.substring(1));

	// nahodime Sentry pro odchytavani chyb
	Sentry.init({
		dsn: 'https://e950253567b9407ebdbbf01c82cf3e64@sentry.pszn.cz/56',
		release: packageJSON.version,
		environment: window.location.hostname + (window.location.port ? `:${window.location.port}` : ''),
		normalizeDepth: 10,
		sampleRate: 0.25,
		ignoreErrors: [
			'NetworkError',
			'OfflineError',
			'ServiceUnavailableError',
			'ChunkLoadError',
			'FastRPCError',
			'AbortError',
			'HTTPError',
			'TimeoutError',
		],
		denyUrls: [
			/graph\.facebook\.com/iu,
			/connect\.facebook\.net\/en_US\/all\.js/iu,
			/eatdifferent\.com\.woopra-ns\.com/iu,
			/static\.woopra\.com\/js\/woopra\.js/iu,
			/extensions\//iu,
			/^chrome:\/\//iu,
			/^chrome-extension:\/\//iu,
			/^moz-extension:\/\//iu,
			/127\.0\.0\.1:4001\/isrunning/iu,
			/webappstoolbarba\.texthelp\.com\//iu,
			/metrics\.itunes\.apple\.com\.edgesuite\.net\//iu,
		],
	});
	Sentry.configureScope(scope => {
		// nacteme si instanceId
		try {
			instanceId = localStorage.getItem('x-instance-id') || '';
		} catch (ex) {
			//
		}

		if (!instanceId) {
			instanceId = urlParams.has('instanceid') ? urlParams.get('instanceid') : uuidv4();
		}

		scope.setUser({
			id: instanceId,
			// eslint-disable-next-line camelcase
			ip_address: '{{auto}}',
		});

		// instanceId ulozime do localStorage
		try {
			localStorage.setItem('x-instance-id', instanceId);
		} catch (ex) {
			//
		}
	});
}
